import { atom } from 'jotai'

import { type DetailInfo } from '@/features/vehicle-dispatch-boards/formatters'

/**
 * 配車時刻を変更中（リサイズ中）の配車予定
 */
export const resizingDispatchScheduleAtom = atom<DetailInfo | null>(null)

resizingDispatchScheduleAtom.debugLabel = 'resizingDispatchScheduleAtom'

/**
 * リサイズを開始した矢羽根の draggable id。
 * ピン止め行は本体行の複製で同じ明細 id を持つため、オーバーレイの位置決めに使う
 * DOM ノードを「どちらの複製から始めたか」まで含めて特定する必要がある。
 */
export const resizingDispatchScheduleSourceIdAtom = atom<string | null>(null)

resizingDispatchScheduleSourceIdAtom.debugLabel =
  'resizingDispatchScheduleSourceIdAtom'
